import React, { Suspense } from "react";
import { HashRouter, Route, Routes } from "react-router-dom";
import "./scss/style.scss";
import Loading from "./views/loading/NormalLoading";
import "./App.css";
import ProtectedRoutes from "./ProtectedRoute";
import { ToastContainer } from "react-toastify";
const DefaultLayout = React.lazy(() => import("./layout/DefaultLayout"));
const LoginWithOtp = React.lazy(() => import("src/views/pages/login/LoginWithOtp"));
import 'react-toastify/dist/ReactToastify.css';
import InActiveLogoutScreen from "./views/pages/login/InActiveLogoutScreen";
const App = () => {
  return (<>
    <ToastContainer autoClose={4000} className="text-capitalize" />
    <HashRouter >
      <Suspense fallback={<Loading />}>
        <Routes>
          <Route path="/login" name="Login Page" element={<LoginWithOtp />} />
          <Route path="/InActiveUserLogout" name="In Active user log out" element={<InActiveLogoutScreen />} />
          <Route path="*" element={<ProtectedRoutes />}>
            <Route path="*" element={<DefaultLayout />} />
          </Route>
        </Routes>
      </Suspense>
    </HashRouter>
  </>
  );
}

export default App